import React from "react";
import { Layer } from "react-konva";
import { useSelector } from "react-redux";
import { Line as LineType, LineConfig } from "konva/types/shapes/Line";
import BuildingLine from "./BuildingLine";
import { buildingLines } from "../../lib/constants";
import { DragescentState } from "../../store/reducers/stateType";

interface IProps {
  handleBuildingHoverIn: (key: string) => void;
  handleBuildingHoverOut: (key: string) => void;
  handleBuildingClick: (buildingElement: LineType<LineConfig> | null, key: string) => void;
}

const CityLayer = ({
  handleBuildingHoverIn,
  handleBuildingHoverOut,
  handleBuildingClick
}: IProps) => {
  const slotChains = useSelector((state: DragescentState) => state.governorate.slotChains);

  return (<Layer>
    {Object.keys(slotChains).map(key => <BuildingLine
      key={`line-${key}`}
      slotKey={key}
      points={buildingLines[slotChains[key].representantName].points}
      buildingHover={handleBuildingHoverIn}
      buildingBlur={handleBuildingHoverOut}
      buildingClick={handleBuildingClick}
    />)}
  </Layer>)
}

export default CityLayer;
